// Helpers
import { isNumeric } from "@/Common/helpers/Verifications/numbers";
import { getFormatAmount, unformattedAmount } from "@/Common/helpers/number";

// MUI
import { SvgIcon } from "@mui/material";

const quarters = {
	zero: 0,
	fifteen: 15,
	half: 30,
	fortyfive: 45,
	sixty: 60,
};

const ranges = {
	first: 0,
	quarter: 25,
	half: 50,
	pastHalf: 75,
	last: 100,
};

const timeQuarters = Object.values(quarters);
const timeRanges = Object.values(ranges);

const SYMBOLS = new Map([
	[
		"DOLLAR",
		{
			symbol: "$",
			styles: null,
		},
	],
	[
		"DOLLAR PER UNIT",
		{
			symbol: "$/u",
			styles: {
				textTransform: "lowercase",
				minWidth: "25px !important",
			},
		},
	],
	[
		"DOLLAR PER DAY",
		{
			symbol: "$/d",
			styles: {
				textTransform: "lowercase",
				minWidth: "25px !important",
			},
		},
	],
	[
		"DOLLAR PER DURATION",
		{
			symbol: (
				<SvgIcon className="input-value-icon" sx={{ padding: "0px", width: "32px" }}>
					<text x="0" y="17" fontSize="14px" style={{ textTransform: "lowercase" }}>
						$/
					</text>
					<svg xmlns="http://www.w3.org/2000/svg" x="13" y="7" width="32" height="13" viewBox="0 0 32 13" fill="none">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M6.5 0.975C3.44863 0.975 0.975 3.44863 0.975 6.5C0.975 9.55137 3.44863 12.025 6.5 12.025C9.55137
							 12.025 12.025 9.55137 12.025 6.5C12.025 3.44863 9.55137 0.975 6.5 0.975ZM0 6.5C0 2.91015 2.91015 0
							 6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5ZM6.175
							 2.1125C6.44424 2.1125 6.6625 2.33076 6.6625 2.6V6.21854L9.79633 8.02781C10.0295 8.16243 10.1094 8.46058
							 9.97478 8.69374C9.84016 8.92691 9.54201 9.00681 9.30884 8.87219L5.93125 6.92219C5.78042 6.83511 5.6875 6.67417
							 5.6875 6.5V2.6C5.6875 2.33076 5.90576 2.1125 6.175 2.1125Z"
							fill="currentColor"
						/>
					</svg>
				</SvgIcon>
			),
			styles: {
				minWidth: "36px !important",
			},
		},
	],
	[
		"DURATION",
		{
			symbol: (
				<SvgIcon className="input-value-icon" sx={{ padding: "4px", fontSize: "22px" }}>
					<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M6.5 0.975C3.44863 0.975 0.975 3.44863 0.975 6.5C0.975 9.55137 3.44863 12.025 6.5 12.025C9.55137
							 12.025 12.025 9.55137 12.025 6.5C12.025 3.44863 9.55137 0.975 6.5 0.975ZM0 6.5C0 2.91015 2.91015 0
							 6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5ZM6.175
							 2.1125C6.44424 2.1125 6.6625 2.33076 6.6625 2.6V6.21854L9.79633 8.02781C10.0295 8.16243 10.1094 8.46058
							 9.97478 8.69374C9.84016 8.92691 9.54201 9.00681 9.30884 8.87219L5.93125 6.92219C5.78042 6.83511 5.6875 6.67417
							 5.6875 6.5V2.6C5.6875 2.33076 5.90576 2.1125 6.175 2.1125Z"
							fill="white"
						/>
					</svg>
				</SvgIcon>
			),
			styles: {
				minWidth: "22px !important",
			},
		},
	],
	[
		"DURATION PER UNIT",
		{
			symbol: (
				<SvgIcon className="input-value-icon" sx={{ padding: "0px", width: "30px" }}>
					<svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
						<path
							transform="translate(2 0)"
							fillRule="evenodd"
							clipRule="evenodd"
							d="M6.5 0.975C3.44863 0.975 0.975 3.44863 0.975 6.5C0.975 9.55137 3.44863 12.025 6.5 12.025C9.55137
							 12.025 12.025 9.55137 12.025 6.5C12.025 3.44863 9.55137 0.975 6.5 0.975ZM0 6.5C0 2.91015 2.91015 0
							 6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5ZM6.175
							 2.1125C6.44424 2.1125 6.6625 2.33076 6.6625 2.6V6.21854L9.79633 8.02781C10.0295 8.16243 10.1094 8.46058
							 9.97478 8.69374C9.84016 8.92691 9.54201 9.00681 9.30884 8.87219L5.93125 6.92219C5.78042 6.83511 5.6875 6.67417
							 5.6875 6.5V2.6C5.6875 2.33076 5.90576 2.1125 6.175 2.1125Z"
							fill="white"
						/>
						<text x="16" y="11" fill="currentColor" fontSize="14.5px" style={{ textTransform: "lowercase" }}>
							/u
						</text>
					</svg>
				</SvgIcon>
			),
			styles: {
				minWidth: "36px !important",
			},
		},
	],
	[
		"PERCENT",
		{
			symbol: "%",
			styles: null,
		},
	],
	[
		"PERCENT PER UNIT",
		{
			symbol: "%/u",
			styles: {
				textTransform: "lowercase",
				minWidth: "25px !important",
			},
		},
	],
	[
		"UNIT",
		{
			symbol: "#",
			styles: null,
		},
	],
]);

const getIndex = (data = [], defaultType = "", key = "type") => {
	if (!defaultType || data?.length <= 1) {
		return 0;
	}
	return data?.findIndex((element) => element[key] === defaultType);
};

const getTypeDefinition = (type = "Unit") =>
	SYMBOLS.get(type?.toUpperCase()) || {
		symbol: "",
		styles: null,
	};

const getDecimalsPlaceHolder = (decimals = 0, isDuration = false, isEditable = false) => {
	if (!isEditable) {
		return "0";
	}

	if (isDuration) {
		return "00h 00m";
	}

	if (!decimals) {
		return "0.0";
	}
	return `0.${"0".repeat(decimals)}`;
};

const getFixedValue = (value) => (Math.sign(Number(value)) < 0 ? Math.ceil(value) : Math.floor(value));

const getEntirePlacesIndex = (value) => {
	const valueString = value.toString();
	const decimalIndex = valueString.indexOf(".");
	return decimalIndex === -1 ? valueString.length : decimalIndex;
};

const getDecimalValue = (value, decimals = 0) => {
	const placesIndex = getEntirePlacesIndex(value);
	const decimalSection = value?.toString().substring(placesIndex, placesIndex + decimals + 1);
	return `0${decimalSection}`;
};

const getDecimalPart = (value = 0, decimals = 0) => {
	if (!decimals) {
		return "0.0";
	}

	if (!value) {
		return `0.${"0".repeat(decimals)}`;
	}

	const number = parseFloat(value);
	const formatter = Intl.NumberFormat("en-US", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		roundingMode: "trunc",
	});
	const formattedValue = formatter.format(number);
	return getDecimalValue(formattedValue, decimals);
};

const countDecimalPlaces = (value = 0) => {
	if (!value) {
		return 0;
	}
	const valueString = value.toString();
	const decimalPart = valueString.split(".")[1];
	return decimalPart ? decimalPart.length : 0;
};

const removeLeadingValues = (value, amount = 1) => {
	if (!value) {
		return "";
	}
	return String(value).slice(amount);
};

const getDecimalPlaces = (value, decimals = 0) => {
	if (!value || !decimals) {
		return "";
	}
	const decimalPart = getDecimalPart(value, decimals);
	return removeLeadingValues(decimalPart);
};

const getCorrectedValue = (value = "", decimalPart = 0.0, decimals = 0) => {
	if (!decimals || value?.toString().includes(".")) {
		return `${value}`;
	}
	return `${value}${removeLeadingValues(decimalPart)}`;
};

const getSectionedValue = (value, decimalPart = 0.0, decimals = 0) => {
	const referenceValue = getCorrectedValue(value, decimalPart, decimals);

	const sign = Math.sign(Number(value));
	const entireValue = getFixedValue(referenceValue);
	const decimalValue = getDecimalPart(referenceValue, decimals);
	const decimalPlaceholder = getDecimalsPlaceHolder(decimals);

	let inputValue = Number(Math.abs(entireValue)) + Number(decimalValue);
	inputValue = sign * inputValue;

	return {
		referenceValue,
		entireValue,
		decimalValue,
		decimalPlaceholder,
		inputValue,
		originalValue: value,
		formattedValue: getFormatAmount(inputValue, decimals),
		unformattedValue: unformattedAmount(inputValue),
	};
};

const hasLeadingZeroes = (value = "") => {
	if (!value) {
		return false;
	}
	const stringValue = value.toString();

	const startsWithValidZero = stringValue.startsWith("0.");
	const startsWithValidNegative = stringValue.startsWith("-0.");
	if (startsWithValidZero || startsWithValidNegative) {
		return false;
	}

	const check = /^(-)?(0+)(?!$)/;
	return check.test(stringValue);
};

const isValidCharacter = (key, nativeEvent) => {
	const regex = /^(\d|-)*(\d+)*\.?\d*$/;
	const { ctrlKey } = nativeEvent || {};
	key = ctrlKey ? `Control ${key}` : key;
	const allowedKeys = ["Backspace", "Delete", "Tab", "Enter", "ArrowLeft", "ArrowRight", "Control c", "Control v"];
	const isKeyAllowed = allowedKeys.includes(key);
	return Boolean(key) && (regex.test(key) || isKeyAllowed);
};

const isDeltaAdmissible = (value = 0, decimals = 0, delta = 0.0) => {
	if (!value || !decimals || !delta) {
		return true;
	}

	const stringValue = value.toString();
	if (stringValue.substring(stringValue.indexOf(".")).length - 1 === decimals) {
		return Math.trunc(parseFloat(value) * Math.pow(10, decimals)) % (parseFloat(delta) * Math.pow(10, decimals)) === 0;
	}

	return true;
};

const getClosestTimeRange = (input, base = 60, range = []) => {
	if (!input || !range.length) {
		return {
			hours: 0,
			minutes: 0,
		};
	}

	let hours = Math.floor(input / base);
	const minutesBase = input % base;

	let minutes = range[0];
	for (let i = 1; i < range.length; i++) {
		if (Math.abs(minutesBase - range[i]) < Math.abs(minutesBase - minutes)) {
			minutes = range[i];
		}
	}

	if (minutes === base) {
		minutes = 0;
		hours += 1;
	}

	return {
		hours,
		minutes,
	};
};

const getHoursAndMinutes = (input, base = 60) => {
	if (!input) {
		return {
			hours: 0,
			minutes: 0,
		};
	}

	let hours = Math.floor(input / base);
	let minutes = input % base;

	return {
		hours,
		minutes,
	};
};

const getInputTimeFormat = (value, exact = false) => {
	const intMinutes = parseInt(value, 10);
	const { minutes, hours } = exact ? getHoursAndMinutes(intMinutes, 100) : getClosestTimeRange(intMinutes, 100, timeRanges);
	return {
		hours,
		minutes: Number((minutes / 100).toFixed(2)),
	};
};

const getClockTimeFormat = (value, exact = false) => {
	const intMinutes = parseInt(value, 10);
	const { minutes, hours } = exact ? getHoursAndMinutes(intMinutes, 60) : getClosestTimeRange(intMinutes, 60, timeQuarters, exact);
	const clockMinutes = {
		0: 0,
		15: 0.25,
		30: 0.5,
		45: 0.75,
	};
	return {
		hours,
		minutes: clockMinutes[minutes] ?? Number((minutes / 60).toFixed(2)),
	};
};

const getConvertedTime = (minutes, isTimeFormat = false, exact = false) =>
	isTimeFormat ? getClockTimeFormat(minutes, exact) : getInputTimeFormat(minutes, exact);

const getTimeSection = (time, index = 0, splitBy = ".") => {
	const timeString = time?.toString()?.toLowerCase();
	return timeString?.split(splitBy)[index] || 0;
};

const getHours = (time, isTimeFormat = false) => {
	if (isNumeric(time)) {
		time = Number(time).toFixed(2);
	}
	const hours = isTimeFormat ? getTimeSection(time, 0, "h") : getTimeSection(time, 0);
	return Number(hours);
};

const getMinutes = (time, isTimeFormat = false) => {
	let minutes = isTimeFormat ? getTimeSection(time, 1, "h") : getTimeSection(time, 1);
	if (minutes?.toString()?.includes("m")) {
		minutes = minutes.replace("m", "");
	}
	return Number(minutes);
};

const getTimeFormat = (time, isTimeFormat = false, exact = false) => {
	const baseHours = getHours(time, isTimeFormat);
	const baseMinutes = getMinutes(time, isTimeFormat);
	const { hours, minutes } = getConvertedTime(baseMinutes, isTimeFormat, exact);
	return {
		minutes,
		hours: baseHours + hours,
		duration: baseHours + hours + minutes,
	};
};

const getDisplayTime = (hours = 0, minutes = 0, exact = false) => {
	const displayHours = hours ? Number(hours) : "00";
	let displayMinutes = "00";
	if (exact) {
		displayMinutes = String(Math.round(minutes * 60)).padStart(2, "0");
	} else {
		const reversedMinutes = {
			0: 0,
			0.25: 15,
			0.5: 30,
			0.75: 45,
		};
		displayMinutes = minutes ? reversedMinutes[minutes] : "00";
	}
	return `${displayHours}h ${displayMinutes}m`;
};

const getTimeDuration = (time, exact = false) => {
	const timeString = time?.toString();
	const timeRegex = /^(\d+h)(\s)?(\d+m)$/;
	const isTimeFormat = timeRegex.test(timeString);
	const isInputFormat = timeString?.includes(".");
	const isDashed = timeString === "-"; // For the time being, we are using this to check if the time is a dash
	const isRecognizedFormat = isTimeFormat || isInputFormat || isNumeric(timeString);

	if (!timeString || isDashed || !isRecognizedFormat) {
		return {
			isDashed,
			isTimeFormat: false,
			duration: 0,
			referenceTime: 0,
			displayTime: "00h 00m",
		};
	}

	let timeToFormat = time;
	if (isInputFormat || isNumeric(timeString)) {
		timeToFormat = Number(timeString).toFixed(2);
	}

	const { duration, hours, minutes } = getTimeFormat(timeToFormat, isTimeFormat, exact);

	return {
		isTimeFormat,
		duration,
		isDashed,
		time,
		referenceTime: isInputFormat ? getCorrectedValue(time, minutes, 2) : time,
		displayTime: getDisplayTime(hours, minutes, exact),
	};
};

export {
	getSectionedValue,
	countDecimalPlaces,
	getIndex,
	getTypeDefinition,
	getDecimalsPlaceHolder,
	getDecimalPlaces,
	getFixedValue,
	getDecimalPart,
	getTimeDuration,
	removeLeadingValues,
	hasLeadingZeroes,
	isDeltaAdmissible,
	isValidCharacter,
};
